import React, { useState } from "react";
import { IEpiProps, ILPReviewerView } from "../models/ilp-page-models";
import { useILPPageContext } from "../reducers/ilp-page-reducers";


interface IProps {
    planForLearner: ILPReviewerView;
}

interface IContextProps {
    epiProps: IEpiProps;
    nfToken: string;
}

export const PlanForLearnerDisplay = (props: IProps) => {
    const { epiProps, nfToken }: IContextProps = useILPPageContext();
    let dateApprovedMessage = props.planForLearner.approvedDate ? props.planForLearner.approvedDate : epiProps.notYetApprovedMessage;
    let ilpPlanLink = props.planForLearner.ilpLink + nfToken;
    let statusClass = () => {

        if (props.planForLearner.planStatus.toLowerCase() === "approved") {
            return "ilp-pill-green";
        }
        else if (props.planForLearner.planStatus.toLowerCase() === "submitted") {
            return "ilp-pill-blue";
        }
        else {
            return "ilp-pill-red";
        }
    }
    return (
        <div className="ilp-card-inner">
            <div className="ilp-card-content-header">
                <p><span className="bold">{epiProps.ilpNameLabel}</span> <a className="ilp-card-link" href={ilpPlanLink} target="_blank">{props.planForLearner.planName} <svg className="svg-icon"> <use xlinkHref="#external-link-icon" /> </svg></a></p>
                <div className="ilp-pill-container">
                    <span className="bold">{epiProps.statusLabel}</span>
                    <span className={statusClass() + " ilp-pill"}> {props.planForLearner.planStatus}</span></div>
            </div>
            <div className="ilp-card-content">
                <p><span className="bold">{epiProps.dateSubmittedLabel}</span> {props.planForLearner.submittedDate}</p>
                <p><span className="bold">{epiProps.dateApprovedLabel}</span> {dateApprovedMessage}</p>
                {props.planForLearner.approvedBy && props.planForLearner.approvedBy.firstName && props.planForLearner.approvedBy.lastName
                    &&
                    <p><span className="bold">{epiProps.approvedByLabel}</span> {props.planForLearner.approvedBy.firstName} {props.planForLearner.approvedBy.lastName}</p>

                }
            </div>
        </div>
    );
}